import { render } from "./AICreateView.vue?vue&type=template&id=41970700&scoped=true"
import script from "./AICreateView.vue?vue&type=script&lang=js"
export * from "./AICreateView.vue?vue&type=script&lang=js"

import "./AICreateView.vue?vue&type=style&index=0&id=41970700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41970700"]])

export default __exports__